export { ContactPage, getServerSideProps } from "./ContactPage";
